import COUNTRIES from '../countries.translations'

import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story11.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story11'
const figure = articleFigure(dir)

export const story11: Article = {
  id: 11,
  slug: 'bolivia-teenagers-mining-for-indium',
  order: 11,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('indium'),
  author: 'Sergio Mendoza',
  // Country-level tag; the pin sits on Potosí, below Cerro Rico.
  region: [
    {
      name: t.regionName,
      country: COUNTRIES.bolivia,
      coordinates: [-65.7531, -19.5836],
      impact: 'human',
    },
  ],
  impactList: ['human', 'geopolitical'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      figure('02.jpg', t.captions[1]),
      { type: 'prose', blocks: [...t.prose[1]] },
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[2]] }, // An indium economy
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[3]] }, // So, where does the indium go?
      figure('04.jpg', t.captions[3]),
      { type: 'prose', blocks: [...t.prose[4]] },
      { type: 'prose', blocks: [...t.prose[5]] }, // The normalisation of underage miners
      { type: 'quote', ...t.quotes[1] },
      { type: 'prose', blocks: [...t.prose[6]] },
      figure('05.jpg', t.captions[4]),
      { type: 'prose', blocks: [...t.prose[7]] }, // The teenage cost of indium
      figure('06.jpg', t.captions[5]),
      { type: 'prose', blocks: [...t.prose[8]] }, // Bolivia’s economic inequality
      figure('07.jpg', t.captions[6]),
      { type: 'prose', blocks: [...t.prose[9]] },
    ],
  },
}
